import { ThemePackage } from '../types/theme';

export class ThemeDefault implements ThemePackage {
  defaultRowSize = 27;
}
